import { required, length, url } from "../utils/validators";

const INPUT_DATA = {
  link: {
    name: {
      value: "",
      type: "input",
      required: true,
      message: "name must not be empty",
      validators: [required, length({ min: 1 })],
      isValid: false,
      touched: false,
    },
    url: {
      value: "",
      required: true,
      message: "please enter a valid url",
      type: "input",
      validators: [required, url],
      isValid: false,
      touched: false,
    },
  },
  RESOURCES_CONTENT_DATA: {
    itemData: {
      name: {
        value: "",
        type: "input",
        required: true,
        message: "name must not be empty",
        validators: [required, length({ min: 1 })],
        isValid: false,
        touched: false,
      },
      description: {
        value: "",
        type: "textarea",
        required: true,
        message: "description must not be empty",
        validators: [required, length({ min: 1 })],
        isValid: false,
        touched: false,
      },
      image: {
        value: "",
        type: "image",
        isValid: false,
        touched: false,
      },
      links: [],
    },
    linksCount: 0,
  },

  RESOURCES_SUPPORT_DATA: {
    itemData: {
      type: {
        value: "",
        type: "input",
        message: "type must not be empty",

        validators: [required, length({ min: 1 })],
        isValid: false,
        touched: false,
        required: true,
      },
      name: {
        value: "",
        type: "input",
        message: "name must not be empty",

        validators: [required, length({ min: 1 })],
        isValid: false,
        touched: false,
        required: true,
      },
      url: {
        value: "",
        type: "input",
        message: "please enter a valid url",

        validators: [required, url],
        isValid: false,
        touched: false,
        required: true,
      },
    },
  },

  ABOUT_DATA: {
    itemData: {
      content: {
        value: "",
        type: "textarea",
        message: "content must not be empty",

        validators: [required, length({ min: 1 })],
        isValid: false,
        touched: false,
        required: true,
      },
    },
  },
};

export default INPUT_DATA;

// PUBLICATION_DATA: {
//   itemData: {
//     name: {
//       value: "",
//       type: "input",
//     },
//     description: {
//       value: "",
//       type: "textarea",
//     },
//   },
//   links: [],
// },
// ACTIVITIE_DATA: {
//   itemData: {
//     name: {
//       value: "",
//       type: "input",
//     },
//     description: {
//       value: "",
//       type: "textarea",
//     },
//   },
//   links: [],
// },
// SDGSPROJECT_DATA: {
//   itemData: {
//     name: {
//       value: "",
//       type: "input",
//     },
//     description: {
//       value: "",
//       type: "textarea",
//     },
//     image: {
//       value: "",
//       type: "image",
//     },
//   },
//   links: [],
// },
// INITIATIVE_DATA: {
//   itemData: {
//     name: {
//       value: "",
//       type: "input",
//     },
//     description: {
//       value: "",
//       type: "textarea",
//     },
//   },
//   links: [],
// },
// CONFERENCE_DATA: {
//   itemData: {
//     name: {
//       value: "",
//       type: "input",
//     },
//     description: {
//       value: "",
//       type: "textarea",
//     },
//   },
//   links: [],
// },
